<template>
  <div></div>
</template>

<script>
  export default {
    name: 'CoreFooter',
  }
</script>
